import { useContext } from 'react';
import { ConsentContext } from './ConsentContext.ts';

export function useConsent() {
  return useContext(ConsentContext);
}
